import React, { useState } from "react";
import {
	Drawer,
	List,
	ListItem,
	Box,
	Button,
	Container,
	Typography,
	Divider,
	TextField,
	Avatar,
	Paper,
	Menu,
	MenuItem,
	Checkbox,
	FormControlLabel,
	FormGroup,
	Card,
	CardContent,
	Grid,
	CardActionArea,
	IconButton,
	Autocomplete,
} from "@mui/material";

import { Close, ExpandLess, ExpandMore } from "@mui/icons-material";
import queryGraphql from "../helpers/ApiInterface";
import { Formik, Form, ErrorMessage } from "formik";
import CompulsoryFieldsLabel from "../helpers/CompulsoryFields";
import * as Yup from "yup";
import { useAuth } from "../helpers/AuthProvider";
import { nameRoleArr, nameRoleObj } from "../helpers/RoleHelper";
import moment from "moment";
import MainDrawer from "./MainDrawer";
import MiniBot from "./MiniBot";
import { useNavigate } from "react-router-dom";



interface OpenDrawer {
	open: boolean; //state of drawer
	edit: boolean; // add/edit
	user: {
		id: string;
		name: string;
		email: string;
		roles: string[];
		clustersViewable: any[];
		applicationsViewable: any[];
	} | null; // User in case of edit else null
}

const UserManagementPage: React.FC = () => {

	const validationSchema = Yup.object().shape({
		name: Yup.string()
			.required("This field is required")
			.matches(/^([A-Z][a-z]*)+(?:\s[A-Z][a-z]*)*$/, `Invalid name`)
			.strict(),
		email: Yup.string()
			.required("This field is required")
			// .matches(/^[a-zA-Z0-9._%+-]+@searce\.com$/, "Invalid domain"), //comment this constraint to allow addition of non searce users
			.test(
				"Authorised-email",
				"Unauthorized email",
				function (value) {
				  if (!value) {
					return false; // Required field, so already handled by `.required()`
				  }
			
				  if (value.endsWith("@searce.com")) {
					return true; // Searce.com users are allowed
				  }
			
				  if (allowedUsers.includes(value)) {
					return true; // User is in the authorized list
				  }
			
				  return false; // Not a Searce.com user and not in the authorized list
				}
			  ),
		roles: Yup.array().required("This field is required").min(1, "Roles cannot be empty"),
		clusters: Yup.array().when("roles", {
			is: (val: any) => {
				return val.some((e: any) => e == "application_owner");
			},
			then: (s) => s.required("This field is required").min(1, "Clusters cannot be empty"),
		}),
		applications: Yup.array().when("roles", {
			is: (val: any) => {
				return val.some((e: any) => e == "developer");
			},
			then: (s) => s.required("This field is required").min(1, "Applications cannot be empty"),
		}),
	});
	
	const { user } = useAuth();
	const navigate = useNavigate();
	const isViewer = user?.roles?.some(
        (role: string) => role === "viewer" 
    ) || false;
	const [applicationOptions, setApplicationOptions] = useState<any>([]);
	const [allowedUsers,setAllowedUsers] = useState<any>([]);
	// const [allowedUser, setAllowedUser] = useState<any>(false);
	// const [currentEmail, setCurrentEmail] = useState<any>();
    const [rerender, setRerender] = useState<any>();
	// // This is to add the users with other domain
	React.useEffect(() => {
			const intervalId = setInterval(() => {
			  setRerender(new Date().toLocaleTimeString());
			}, 2000);
		
			return () => {
			  clearInterval(intervalId);
			};
		  }, []);

	// React.useEffect(() => {
	// 	(async () => {
	// 		try {
	// 			const data = await queryGraphql(`
	// 							query Query {
	// 								getAuthorisedUsers {
	// 									email
	// 								}
	// 								}
	// 	`);

	// 			if (data.getAuthorisedUsers) {
	// 				const emails: string[] = data.getAuthorisedUsers.map((item: any) => item.email);
	// 				if(emails.includes(currentEmail)){
	// 					setAllowedUser(true);
	// 				}else{
	// 					setAllowedUser(false);
	// 				}
					
	// 				console.log("jHello ",allowedUser);
	// 			}
	// 		} catch (error) {
	// 			console.log(error);
	// 		}
	// 	})();
	// }, [rerender]);

React.useEffect(() => {
		(async () => {
			try {
				const data = await queryGraphql(`
								query Query {
									getAuthorisedUsers {
										email
									}
									}
		`);

				if (data.getAuthorisedUsers) {
					const emails: string[] = data.getAuthorisedUsers.map((item: any) => item.email);
					setAllowedUsers(emails);
				}
			} catch (error) {
				console.log(error);
			}
		})();
	}, [rerender]);

	React.useEffect(() => {
		(async () => {
			try {
				const data = await queryGraphql(`
								query{
								users {
								id,
								name,
								email,
								roles,
								googleProfilePicture,
								createdAt,
						
								clustersViewable{
								id,
								clusterName,
								status,
								}, 
								applicationsViewable{
								id,
								applicationName,
								status,
								}
								}
								}
		`);
				if (data?.users) {
					setUsers(data.users);
				}
			} catch (error) {}
		})();
	}, []);
	React.useEffect(() => {
		(async () => {
			try {
				const data = await queryGraphql(`
								query{
								clusters {
								id,
								clusterName,
								status,
								applications{
								id,
								applicationName,
								status
								}
								}
								}
		`);

				if (data?.clusters) {
					setClusters(data.clusters);
					setApplicationOptions(
						data.clusters
							.map((e: any) => e.applications)
							.flat()
							.filter((e: any) => e.status == "active")
					);
				}
			} catch (error) {
				console.log(error);
			}
		})();
	}, []);

	const [searchQuery, setSearchQuery] = useState("");
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [anchorEl1, setAnchorEl1] = useState<null | HTMLElement>(null);
	const [cardHoverIndex, setCardHoverIndex] = useState<number | null>(null);
	const [listView, setListView] = useState<boolean>(false);
	const [roleFilters, setRoleFilters] = useState<any>({
		idp_admin: true,
		application_owner: true,
		cluster_owner: true,
		developer: true,
		infrastructure_admin: true,
		viewer: true,
	});
	const [users, setUsers] = useState<Array<any>>([]);
	const [clusters, setClusters] = useState<Array<any>>([]);
	const [open, setOpen] = React.useState<OpenDrawer>({ open: false, edit: false, user: null });

	// const handleFilterClick = (event: React.MouseEvent<HTMLElement>) => {
	// 	setAnchorEl(event.currentTarget);
	// };

	// const handleFilterClose = () => {
	// 	setAnchorEl(null);
	// };
	const handleFilterClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleFilterClose = () => {
		setAnchorEl(null);
	};

	const filteredUsers = users.filter((user) => {
		return (
			user.roles.length > 0 &&
			user.roles.some((element: string) => roleFilters[element]) &&
			(user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
				user.email.toLowerCase().includes(searchQuery.toLowerCase()))
		);
	});

	const roleColorConfig: any = {
		idp_admin: {
			border: "#00DC96",
			bg: "#00DC9610",
		},
		cluster_owner: {
			border: "#FFB413",
			bg: "#FFB41310",
		},
		developer: {
			border: "#333333",
			bg: "#33333310",
		},
		application_owner: {
			border: "#FF2950",
			bg: "#FF295010",
		},
		infrastructure_admin: {
			border: "#5B50E0",
			bg: "#5B50E010",
		},
		viewer: {
			border: "#C4C4C4",
			bg: "#FFFFFF",
		}
	};

	return (
		<Box sx={{ display: "flex" }}>
			<MiniBot/>
			<MainDrawer index={"user-management"} />
			<Box
				component="main"
				sx={{
					flexDirection: "column",
					flex: 1,
					bgcolor: "#fafafa",
					minHeight: window.innerHeight,
				}}
			>
				<Container maxWidth={false} disableGutters>
					<Box bgcolor="white" sx={{ p: 2, mb: 2 }}>
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								mx: 2,
							}}
						>
							<Typography gutterBottom fontSize="22px" fontFamily="Gilroy-Bold">
								User Management
							</Typography>
							 <Box sx={{display:'flex', justifyContent:'center'}}>
							<Button
								variant="contained"
								color="primary"
								sx={{
									backgroundColor: "black",
									color: "white",
									padding: "8px 24px",
									fontSize: "0.875rem",
									textTransform: "none",
								}}
								onClick={() => setOpen({ open: true, edit: false, user: null })}
								disabled={isViewer}
							>
								<Typography fontSize="14px" fontFamily="Gilroy-Bold">
									Add New User
								</Typography>
							</Button>
								<IconButton
																	  aria-label="Help" 
																	  onClick={()=> window.open(`${process.env.REACT_APP_HOST_DOMAIN}/docs` , "_blank")}
																	  sx={{
																		padding: 0, 
																		border: 'none',  
																		ml:2,
																		'&:hover': {
																		  
																		  backgroundColor: 'action.hover', 
																		},
																		
																	  }}
																	>
																	  <Box
																		component="img"
																		src="/assets/Help.svg" 
																		alt="" 
																		sx={{
																		  width: 40,  
																		  height: 40,
																		  display: 'block', 
																		}}
																	  />
																	</IconButton>
							</Box>
						</Box>
						<Divider sx={{ marginY: 1 }} />
						<Box
							sx={{
								display: "flex",

								justifyContent: "space-between",
								alignItems: "center",
								mx: 2,
							}}
						>
							<Box>
								<Typography fontSize="16px" fontFamily="Gilroy-Bold">
									{`USERS (${filteredUsers.length})`}
								</Typography>
								<Typography fontSize="14px" color="#666666" fontFamily="Gilroy-Regular">
									Add new users and edit user details.
								</Typography>
							</Box>
							<Box
								sx={{
									display: "flex",

									marginBottom: 2,
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<TextField
									variant="filled"
									placeholder="Search by user name..."
									value={searchQuery}
									size="small"
									hiddenLabel
									onChange={(e) => setSearchQuery(e.target.value)}
									InputProps={{
										startAdornment: (
											<img
												src="/assets/search-normal.svg"
												alt="Filter Icon"
												style={{ width: "14px", marginRight: "8px" }}
											/>
										),
										disableUnderline: true,
										style: {
											backgroundColor: "#f4f4f4",
											height: "45px",
											width: "350px",
											borderRadius: "8px",
											fontFamily: "Gilroy-Regular",
											fontSize: "14px",
										},
									}}
								/>
								<Box mx={0.5}>
									<Button
										sx={{
											marginLeft: "16px",
											height: "45px",
											width: "100px",
											textTransform: "none",
											textAlign: "start",
											color: "#666666",
											border: "1px solid #666666",
											borderRadius: "4px",
										}}
										onClick={handleFilterClick}
									>
										<Typography color="#666666" fontSize="14px" textAlign="start" mr={2}>
											Roles
										</Typography>
										{anchorEl ? <ExpandLess /> : <ExpandMore />}
									</Button>
									<Menu
										anchorEl={anchorEl}
										open={Boolean(anchorEl)}
										onClose={handleFilterClose}
										anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
									>
										<Box px={1} py={1}>
											<Typography fontSize="16px" textAlign="start">
												Roles
											</Typography>
											<FormGroup>
												{nameRoleArr.map(({ role, name }) => (
													<FormControlLabel
														// key={column}
														control={
															<Checkbox
																checked={roleFilters[role]}
																onChange={() => {
																	setRoleFilters({
																		...roleFilters,
																		[role]: !roleFilters[role],
																	});
																}}
																sx={{
																	color: "#000", // Black color for the checkbox
																	"&.Mui-checked": {
																		color: "#000", // Black color when checked
																	},
																	"& .MuiSvgIcon-root": {
																		borderRadius: "50%", // Rounded shape for the checkbox icon
																	},
																}}
															/>
														}
														label={name}
													/>
												))}
											</FormGroup>
										</Box>
									</Menu>
								</Box>
								<Box ml="16px">
									<Button
										sx={{ bgcolor: listView ? "#F0F0F0" : "#000000", height: "45px" }}
										onClick={() => setListView(false)}
									>
										<img alt="alt" src="/assets/grid-tidy.svg" />
									</Button>
									<Button
										sx={{ bgcolor: listView ? "#000000" : "#F0F0F0", height: "45px" }}
										onClick={() => setListView(true)}
									>
										<img alt="alt" src="/assets/vertical.svg" />
									</Button>
								</Box>
							</Box>
						</Box>
					</Box>
					{listView ? (
						<Box m={2}>
							<List sx={{ bgcolor: "#fafafa" }}>
								<ListItem sx={{ mb: "16px" }}>
									<Box width="100%">
										<Grid container direction="row">
											<Grid item xs={3}>
												<Typography fontSize="12px">NAME</Typography>
											</Grid>
											<Grid item xs={3}>
												<Typography fontSize="12px">EMAIL</Typography>
											</Grid>
											<Grid textAlign="start" item xs={4}>
												<Typography fontSize="12px">ROLES</Typography>
											</Grid>
											<Grid item textAlign="start" xs={2}>
												<Typography fontSize="12px">CREATED AT</Typography>
											</Grid>
										</Grid>
									</Box>
								</ListItem>
								{filteredUsers.map((e: any, index) => (
									<ListItem
										sx={{
											border: cardHoverIndex == index ? "1px solid #000" : "1px solid #00000000",
											mb: "12px",
											bgcolor: "#fff",
											borderRadius: "8px",
											cursor: "pointer",
										}}
										onMouseEnter={() => setCardHoverIndex(index)}
										onMouseLeave={() => {
											setCardHoverIndex(null);
										}}
									>
										<Box width="100%" sx={{}}>
											<Grid container direction="row">
												<Grid item xs={3}>
													<Box height="100%" sx={{ display: "flex", alignItems: "center" }}>
														<Avatar
															src={e.googleProfilePicture}
															alt="Dp"
															sx={{ height: "40px", width: "40px", mr: "12px" }}
														></Avatar>
														<Typography fontFamily="Gilroy-SemiBold" fontSize="14px">
															{e?.email == user.email ? e?.name + " (Self)" : e?.name}
														</Typography>
													</Box>
												</Grid>
												<Grid item xs={3}>
													<Box
														height="100%"
														sx={{
															display: "flex",
															alignItems: "center",
															justifyContent: "flex-start",
														}}
													>
														<Typography fontFamily="Gilroy-Regular" fontSize="14px">
															{e?.email}
														</Typography>
													</Box>
												</Grid>
												<Grid item xs={4}>
													<Box
														height="100%"
														display="flex"
														justifyContent="flex-start"
														alignItems="center"
													>
														<Grid
															container
															justifyContent="flex-start"
															alignItems="center"
															spacing={0.5}
														>
															{e.roles?.map((role: string) => {
																return (
																	<Grid item xs={5}>
																		<Paper
																			elevation={0}
																			sx={{
																				height: "100%",
																				borderRadius: 5,
																				bgcolor: roleColorConfig[role].bg,
																				border: `1px solid ${roleColorConfig[role].border}`,
																			}}
																		>
																			<Typography
																				textAlign="center"
																				fontSize="12px"
																				fontFamily="Gilroy-Medium"
																				px="1px"
																			>
																				{nameRoleObj[role]}
																			</Typography>
																		</Paper>
																	</Grid>
																);
															})}
														</Grid>
													</Box>
												</Grid>
												<Grid item xs={2}>
													<Box
														height="100%"
														sx={{
															display: "flex",
															alignItems: "center",
															justifyContent: "space-between",
															pl: 1,
														}}
													>
														<Typography fontFamily="Gilroy-Regular" fontSize="14px">
															{moment(Number(e?.createdAt)).format("DD/MM/YYYY")}
														</Typography>
														<>
															<IconButton
																sx={{ p: 0, ml: 2, opacity: cardHoverIndex == index ? "1" : "0" }}
																disabled={isViewer}
																onClick={(event) => {
																	setAnchorEl1(event.currentTarget);
																}}
															>
																<img src="/assets/option-icon.svg" alt="options" />
															</IconButton>
															<Menu
																id="basic-menu"
																anchorEl={anchorEl1}
																open={Boolean(anchorEl1)}
																onClose={() => setAnchorEl1(null)}
															>
																<MenuItem
																	onClick={() => {
																		setOpen({ open: true, edit: true, user: e });
																		setAnchorEl1(null);
																	}}
																>
																	<img alt="edit" src="/assets/edit-2.svg" />
																	<Typography ml="16px">Edit User Details</Typography>
																</MenuItem>
																<MenuItem
																	onClick={async () => {
																		const data = await queryGraphql(
																			`
																							mutation DeleteUser($deleteUserId: String!) {
  deleteUser(id: $deleteUserId) {
	id
  }
}
																	`,
																			{
																				deleteUserId: e.id,
																			}
																		);
																		if (data.deleteUser.id) {
																			setUsers([
																				...users.filter((e) => e.id != data.deleteUser.id),
																			]);
																			setAnchorEl1(null);
																		}
																	}}
																>
																	<img alt="delete" src="/assets/trash.svg" />
																	<Typography ml="16px" color="red">
																		Delete User
																	</Typography>
																</MenuItem>
															</Menu>
														</>
													</Box>
												</Grid>
											</Grid>
										</Box>
									</ListItem>
								))}
							</List>
						</Box>
					) : (
						<Box m={2}>
							<Grid
								container
								alignItems="center"
								justifyContent="flex-start"
								direction="row"
								spacing={3}
							>
								{filteredUsers.map((e: any, index) => {
									return (
										<Grid item>
											<Card
												elevation={0}
												sx={{
													width: 250,
													borderRadius: "12px",
													minHeight: 220,
													display: "flex",
													bgcolor: cardHoverIndex == index ? "#GGGGGG" : "#FFFFFF",
													flexGrow:1,
													border:
														cardHoverIndex == index ? "1px solid #666666" : "1px solid #66666600",
												}}
											>
												<CardActionArea
													onMouseEnter={() => setCardHoverIndex(index)}
													onMouseLeave={() => {
														setCardHoverIndex(null);
													}}
												>
													<CardContent sx={{ py: "8px", justifyContent: "center" , flexGrow:1, minHeight:200}}>
														<Box
															display="flex"
															flexDirection="column"
															alignItems="center"
															
															justifyContent="center"
															flexGrow={1}
														>
															<Avatar
																src={e.googleProfilePicture}
																alt="Dp"
																sx={{ marginBottom: "16px", height: "60px", width: "60px" }}
															></Avatar>
															<Box display="flex" position="absolute" top="0" right="0">
																{cardHoverIndex == index && (
																	<>
																		<IconButton
																			onClick={(event) => setAnchorEl1(event.currentTarget)}
																			disabled={isViewer}
																		>
																			<img src="/assets/option-icon.svg" alt="options" />
																		</IconButton>
																		<Menu
																			id="basic-menu"
																			anchorEl={anchorEl1}
																			open={Boolean(anchorEl1)}
																			onClose={() => setAnchorEl1(null)}
																		>
																			<MenuItem
																				onClick={() => {
																					setOpen({ open: true, edit: true, user: e });
																					setAnchorEl1(null);
																				}}
																			>
																				<img alt="edit" src="/assets/edit-2.svg" />
																				<Typography ml="16px">Edit User Details</Typography>
																			</MenuItem>
																			<MenuItem
																				onClick={async () => {
																					const data = await queryGraphql(
																						`
																							mutation DeleteUser($deleteUserId: String!) {
  deleteUser(id: $deleteUserId) {
    id
  }
}
																	`,
																						{
																							deleteUserId: e.id,
																						}
																					);
																					if (data.deleteUser?.id) {
																						setUsers([
																							...users.filter((e) => e.id != data.deleteUser?.id),
																						]);
																						setAnchorEl1(null);
																					}
																				}}
																			>
																				<img alt="delete" src="/assets/trash.svg" />
																				<Typography ml="16px" color="red">
																					Delete User
																				</Typography>
																			</MenuItem>
																		</Menu>
																	</>
																)}
															</Box>

															<Typography fontFamily="Gilroy-Bold" fontSize="14px">
																{e?.email == user.email ? e?.name + " (Self)" : e?.name}
															</Typography>
															<Typography
																fontFamily="Gilroy-Regular"
																fontSize="12px"
																sx={{ mb: "8px" }}
															>
																{e?.email}
															</Typography>
															<Grid
																container
																justifyContent="center"
																alignItems="center"
																spacing={1}
															>
																{e.roles.map((role: string) => {
																	return (
																		<Grid item>
																			<Paper
																				elevation={0}
																				sx={{
																					height: "100%",
																					px: 1,
																					borderRadius: 5,
																					bgcolor: roleColorConfig[role].bg,
																					border: `1px solid ${roleColorConfig[role].border}`,
																				}}
																			>
																				<Typography
																					textAlign="center"
																					fontSize="12px"
																					fontFamily="Gilroy-Medium"
																				>
																					{nameRoleObj[role]}
																				</Typography>
																				{/* </Box> */}
																			</Paper>
																		</Grid>
																	);
																})}
															</Grid>
														</Box>
													</CardContent>
												</CardActionArea>
											</Card>
										</Grid>
									);
								})}
							</Grid>
						</Box>
					)}
				</Container>

				<Drawer
					variant="temporary"
					anchor="right"
					open={open.open}
					onClose={() => setOpen({ open: false, edit: false, user: null })}
					sx={{
						maxWidth: 300,

						[`& .MuiDrawer-paper`]: {
							maxWidth: 300,
							boxSizing: "border-box",
							backgroundColor: "white",
							color: "black",
						},
					}}
				>
					<Formik
						initialValues={{
							name: open?.user?.name || "",
							email: open?.user?.email || "",
							roles: open?.user?.roles || [],
							clusters: open.user?.clustersViewable, //.map((e) => e.id) || [],
							applications: open.user?.applicationsViewable || [],
						}}
						validationSchema={validationSchema}
						onSubmit={async ({ name, email, roles, clusters, applications }) => {
							if (open.edit) {
								const data = await queryGraphql(
									`
												mutation UpdateUser($input: UserUpdateInput) {
  updateUser(input: $input) {
    id
	
  }
}
						`,
									{
										input: {
											id: open.user?.id,
											name,
											email,
											roles,
											clusters: roles.some((e) => ["application_owner", "developer"].includes(e))
												? clusters?.map((e) => e.id)
												: undefined,
											applications: roles.some((e) => e.includes("developer"))
												? applications?.map((e) => e.id)
												: undefined,
										},
									}
								);
								if (data.updateUser.id) {
									setOpen({ open: false, edit: false, user: null });
									setUsers([
										...users.map((user: any) => {
											if (user.id == data.updateUser.id) {
												return {
													...user,
													email,
													roles,
													name,
													clustersViewable: clusters?.map((e) => {
														return { ...e, status: "ACTIVE" };
													}),
													applicationsViewable: applications?.map((e) => {
														return { ...e, status: "ACTIVE" };
													}),
												};
											}
											return user;
										}),
									]);
								}
							} else {
								const data = await queryGraphql(
									`
												mutation CreateUser($input: UserCreateInput) {
  createUser(input: $input) {
    id,

  }
}
						`,
									{
										input: {
											name,
											email,
											roles,
											clusters: roles.some((e) => ["application_owner", "developer"].includes(e))
												? clusters?.map((e) => e.id)
												: undefined,
											applications: roles.some((e) => e.includes("developer"))
												? applications?.map((e) => e.id)
												: undefined,
										},
									}
								);
								if (data.createUser.id) {
									setOpen({ open: false, edit: false, user: null });
									setUsers([
										...users,
										{
											id: data.createUser.id,
											name,
											email,
											roles,
											clustersViewable: clusters?.map((e) => {
												return { ...e, status: "ACTIVE" };
											}),
											applications: applications?.map((e) => {
												return { ...e, status: "ACTIVE" };
											}),
										},
									]);
								}
							}
						}}
					>
						{({
							handleChange,
							handleBlur,
							values,
							setFieldValue,
							errors,
							touched,
							isValid,
							dirty,
						}) => (
							<Form>
								<Box display="flex" alignItems="center" justifyContent="flex-start" p="12px">
									<IconButton onClick={() => setOpen({ open: false, edit: false, user: null })}>
										<Close />
									</IconButton>
									<Typography fontSize="20px" fontFamily="Gilroy-SemiBold" ml="12px">
										{open.edit ? "Edit user" : "Add New User"}
									</Typography>
								</Box>
								<Divider />
								<Box p="20px">
									<Typography fontSize="16px">
										{open.edit
											? "Update the below details and save changes"
											: "Fill the below details to add user"}
									</Typography>
									<Box display="flex">
										<Typography fontFamily="Gilroy-Regular" marginBottom="16px" fontSize="12px">
											Fields marked with
										</Typography>
										<Typography
											fontFamily="Gilroy-Regular"
											marginBottom="16px"
											fontSize="12px"
											color="red"
											mx="2px"
										>
											*
										</Typography>
										<Typography fontFamily="Gilroy-Regular" marginBottom="16px" fontSize="12px">
											are mandatory
										</Typography>
									</Box>
									<Box>
										<Box mb="32px">
											<CompulsoryFieldsLabel fieldName="Full Name" />
											<TextField
												variant="filled"
												fullWidth
												name="name"
												// onChange={(e: any) => setClusterName(e.target.value)}
												value={values.name}
												onChange={handleChange}
												onBlur={handleBlur}
												placeholder="Enter name here"
												size="medium"
												hiddenLabel
												InputProps={{
													disableUnderline: true,
													style: {
														borderRadius: "8px",
													},
												}}
											/>
											<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
												<ErrorMessage name="name" component="div" />
											</div>
										</Box>
										<Box mb="32px">
											<CompulsoryFieldsLabel fieldName="Email" />
											<TextField
												variant="filled"
												fullWidth
												// value={gcpProjectId}
												// onChange={(e) => setGcpProjectId(e.target.value)}
												name="email"
												value={values.email}
												// onChange={handleChange}
												onChange={(e:any) =>{
													handleChange(e);
													// setCurrentEmail(e.target.value);
												}}
												onBlur={handleBlur}
												placeholder="Email"
												size="medium"
												hiddenLabel
												InputProps={{
													disableUnderline: true,
													style: {
														borderRadius: "8px",
													},
												}}
											/>
											<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
												<ErrorMessage name="email" component="div" />
											</div>
										</Box>
										{values.roles.includes("application_owner") ||
										values.roles.includes("developer") ? (
											<Box mb="32px">
												<CompulsoryFieldsLabel fieldName="Clusters" />
												<Autocomplete
													multiple
													options={clusters?.filter((e) => e.status.toLowerCase() == "active")}
													getOptionLabel={(option) => option.clusterName}
													filterSelectedOptions
													ChipProps={{ size: "small" }}
													defaultValue={
														open?.user?.clustersViewable &&
														open?.user?.clustersViewable?.length > 0
															? clusters.filter((e) =>
																	open.user?.clustersViewable.map((e) => e.id).includes(e.id)
															  )
															: []
													}
													onChange={(e, newVal, reason) => {
														// setApplicationOwners(newVal);

														setFieldValue("clusters", newVal);

														setApplicationOptions(
															newVal
																.map((e) => e.applications)
																.flat(2)
																.filter((e) => e.status == "active")
														);
													}}
													// filterOptions={(options) =>
													// 	options.filter(
													// 		(e) => !open.user?.clustersViewable.map((e) => e.id).includes(e.id)
													// 	)
													// }
													renderInput={(params) => (
														<TextField
															{...params}
															variant="filled"
															fullWidth
															placeholder="Select"
															size="small"
															hiddenLabel
															InputProps={{
																...params.InputProps,
																style: {
																	borderRadius: "8px",
																},
																disableUnderline: true,
															}}
														/>
													)}
												/>
												<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
													{/* <ErrorMessage name="a" component="div" /> */}
												</div>
											</Box>
										) : (
											<></>
										)}
										{values.roles.includes("developer") ? (
											<Box mb="32px">
												<CompulsoryFieldsLabel fieldName="Applications" />
												<Autocomplete
													multiple
													options={applicationOptions}
													getOptionLabel={(option: any) => option.applicationName}
													filterSelectedOptions
													ChipProps={{ size: "small" }}
													defaultValue={
														open?.user?.applicationsViewable &&
														open?.user?.applicationsViewable?.length > 0
															? applicationOptions.filter((e: any) =>
																	open.user?.applicationsViewable.map((e) => e.id).includes(e.id)
															  )
															: []
													}
													onChange={(e, newVal, reason) => {
														setFieldValue("applications", newVal);
													}}
													renderInput={(params) => (
														<TextField
															{...params}
															variant="filled"
															fullWidth
															placeholder="Select"
															size="small"
															hiddenLabel
															InputProps={{
																...params.InputProps,
																style: {
																	borderRadius: "8px",
																},
																disableUnderline: true,
															}}
														/>
													)}
												/>
												<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
													{/* <ErrorMessage name="a" component="div" /> */}
												</div>
											</Box>
										) : (
											<></>
										)}
										<Box>
											<CompulsoryFieldsLabel fieldName="Roles" />
											<Box display="flex" flexDirection="column">
												{nameRoleArr.map((e) => {
													return (
														<FormControlLabel
															control={
																<Checkbox
																	sx={{
																		"& .MuiSvgIcon-root": {
																			// fontSize: 28,
																			color: "black",
																		},

																		"&.Mui-checked": {
																			// backgroundColor: "black",
																			bgcolor: "white",
																		},
																	}}
																	checked={values.roles.includes(e.role)}
																/>
															}
															label={e.name}
															name="roles"
															onChange={() => {
																setFieldValue(
																	"roles",
																	values.roles.includes(e.role)
																		? [...values.roles.filter((role: string) => role != e.role)]
																		: [...values.roles, e.role]
																);
															}}
															onBlur={handleBlur}
														/>
													);
												})}
												<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
													<ErrorMessage name="roles" component="div" />
												</div>
											</Box>

											<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
												<ErrorMessage name="role" component="div" />
											</div>
										</Box>
									</Box>
								</Box>
								<Divider />
								<Box display="flex" alignItems="flex-end" justifyContent="center" gap={2} m="20px">
									<Button
										sx={{
											color: "black",
											borderColor: "black",
											fontWeight: "bold",
										}}
										fullWidth
										variant="outlined"
										size="large"
										onClick={() => setOpen({ edit: false, open: false, user: null })}
									>
										Cancel
									</Button>
									<Button
										sx={{
											backgroundColor: "black",
											color: "white",
											fontWeight: "bold",
											"&:hover": {
												backgroundColor: "white",
												color: "black",
												borderColor: "black",
											},
											whiteSpace: "noWrap",
										}}
										fullWidth
										variant="contained"
										size="large"
										type="submit"
										disabled={!isValid}
										// disabled={isValid ?( allowedUser ? (open.edit? false : false): (open.edit? false : true)) : ( allowedUser ? true: true) } //&& dirty}
									>
										{open.edit ? "Save Changes" : "Add New User"}
									</Button>
								</Box>
							</Form>
						)}
					</Formik>
				</Drawer>
			</Box>
		</Box>
	);
};

export default UserManagementPage;
